export type ApiBaseUrls = {
  emsServerUrl: string;
  eedServerUrl: string;
};

let baseUrls: ApiBaseUrls | undefined;

export function configureApiBaseUrls(urls: ApiBaseUrls): void {
  baseUrls = { ...urls };
}

export function getEmsServerUrl(): string {
  if (baseUrls === undefined) {
    throw new Error('API base URLs are not configured. Call configureApiBaseUrls() during bootstrap first.');
  }
  return baseUrls.emsServerUrl;
}

export function getEedServerUrl(): string {
  if (baseUrls === undefined) {
    throw new Error('API base URLs are not configured. Call configureApiBaseUrls() during bootstrap first.');
  }
  return baseUrls.eedServerUrl;
}
